import { createApp } from 'vue'
import App from './App.vue'

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import mn from 'element-plus/es/locale/lang/mn'
import i18n from '@/core/plugins/i18n'

// import './registerServiceWorker'

import * as filters from './filters' // global filters

//imports for app initialization
// import MockAdapter from '@/core/mock/MockService'
import ApiService from '@/core/services/ApiService'
import { initApexCharts } from '@/core/plugins/apexcharts'
import { initInlineSvg } from '@/core/plugins/inline-svg'
import { initVeeValidate } from '@/core/plugins/vee-validate'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import '@/core/plugins/keenthemes'
import '@/core/plugins/prismjs'
import 'bootstrap'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(ElementPlus, {
  locale: mn,
  // size: 'small',
})

// register global utility filters.
app.config.globalProperties.$filters = filters
// {
//   currencyUSD(value) {
//     return '$' + value
//   },
// }

ApiService.init(app)
// MockAdapter.init(app)
initApexCharts(app)
initInlineSvg(app)
initVeeValidate()

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(i18n)

app.mount('#app')
